import ImageUtil from "../../../utils/image"

export default () => (
    <div className="rotate" style={{display: 'none'}}>
        <ImageUtil
            className="animate__animated animate__pulse animate__infinite"
            path={`/images/rotate.png`}
            alt="Rotate" />

        <div className="rotate-text">Please rotate your device</div>
    </div>
)